
  document.addEventListener("DOMContentLoaded", () => {
    const contactForm = document.querySelector(".js-made-to-measure-form form");
    const submitButton = document.getElementById("form-submit-button");
    const fillText = document.getElementById("form-fill-text");

    if (!contactForm) {
      return;
    }

    if (window.location.pathname.includes("/products/") && window.location.search.includes("contact_posted=true")) {
      document.getElementById("made-to-measure-modal").style.display = "block";
      document.body.style.overflow = "hidden";
    }

    const validateForm = () => {
      let errors = [];
      let preventSubmit = false;

      const requiredFields = contactForm.querySelectorAll(".field-required");
      const email = document.getElementById("mtm-contact-email");
      const emailConfirm = document.getElementById("mtm-contact-email-confirm");
      const emailVal = email ? email.value : '';
      const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

      requiredFields.forEach(field => {
        if (field.type === "checkbox") {
          if (!field.checked) {
            preventSubmit = true;
            errors.push(`The field ${field.name} is required.`);
            field.classList.add("checkbox-error");
          } else {
            field.classList.remove("checkbox-error");
          }
        } else {
          if (field.value === "" || field.value === "Please Select *") {
            preventSubmit = true;
            errors.push(`The field ${field.name} is required.`);
            field.classList.add("is-empty");
          } else {
            field.classList.remove("is-empty");
          }
        }
      });

      if (emailConfirm && emailVal !== emailConfirm.value) {
        errors.push("Emails must match.");
        preventSubmit = true;
        emailConfirm.classList.add("is-empty");
      } else if (emailConfirm) {
        emailConfirm.classList.remove("is-empty");
      }

      if (!emailRegex.test(emailVal)) {
        errors.push("The email is not valid.");
        if (email) {
          email.classList.add("is-empty");
        }
        preventSubmit = true;
      } else if (email) {
        email.classList.remove("is-empty");
      }

      fillText.style.display = preventSubmit ? "block" : "none";
      submitButton.disabled = preventSubmit;

      if (preventSubmit) {
        console.log("Form submission prevented due to errors");
      } else {
        console.log("No errors. Form can be submitted.");
      }
    };

    validateForm();

    contactForm.addEventListener("submit", (e) => {
      validateForm();

      if (submitButton.disabled) {
        e.preventDefault();
        alert("Please correct the following errors:\n" + errors.join("\n"));
        console.log("Form submission prevented due to errors");
      } else {
        console.log("No errors. Form will be submitted.");
        fillText.style.display = 'none'; // Hide the <p> element after successful submission
      }
    });

    contactForm.querySelectorAll('input.field-required:not([type="checkbox"])').forEach(input => {
      input.addEventListener("keyup", validateForm);
      input.addEventListener("change", validateForm);
    });

    contactForm.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener("change", validateForm);
    });

    document.getElementById("made-to-measure").addEventListener("click", (e) => {
      e.preventDefault();
      document.getElementById("made-to-measure-modal").style.display = "block";
      document.body.style.overflow = "hidden";
    });

    document.getElementById("made-to-measure-quote-modal-close").addEventListener("click", () => {
      document.getElementById("made-to-measure-modal").style.display = "none";
      document.body.style.overflow = "";
    });

    const setupDropdown = (triggerClass, dropdownClass, inputId) => {
      const triggerElement = document.querySelector(triggerClass);
      const dropdownElement = document.querySelector(dropdownClass);

      if (!triggerElement || !dropdownElement) {
        console.error("Dropdown elements not found.");
        return;
      }

      triggerElement.addEventListener("click", () => {
        const span = triggerElement.querySelector("span");
        span.classList.toggle("blind-quote__dropdown-trigger--active");
        dropdownElement.style.display = dropdownElement.style.display === "block" ? "none" : "block";
      });

      document.querySelectorAll(`${dropdownClass} .js-quote-fabric`).forEach((fabric) => {
        fabric.addEventListener("click", () => {
          const fabricTitle = fabric.querySelector("span").innerText;

          const inputElement = document.getElementById(inputId);
          inputElement.value = fabricTitle;

          document.querySelectorAll(`${dropdownClass} .js-quote-fabric`).forEach((el) =>
            el.classList.remove("blind-quote__fabric-entry--active")
          );
          fabric.classList.add("blind-quote__fabric-entry--active");
          dropdownElement.style.display = "none";
          
          validateForm();
        });
      });
    };

    const setupFabricDropdown = () => {
      const triggerElement = document.querySelector(".js-quote-dropdown-trigger-blinds");
      const dropdownElement = document.querySelector(".blind-quote__fabric-dropdown-curtains");

      if (!triggerElement || !dropdownElement) {
        console.error("Fabric dropdown elements not found.");
        return;
      }

      triggerElement.addEventListener("click", function () {
        const span = this.querySelector("span");
        span.classList.toggle("blind-quote__dropdown-trigger--active");
        dropdownElement.style.display = dropdownElement.style.display === "block" ? "none" : "block";
      });

      document.querySelectorAll(".blind-quote__fabric-dropdown-curtains .js-quote-fabric-blinds").forEach((fabric) => {
        fabric.addEventListener("click", function () {
          const fabricTitle = this.querySelector("span").innerText;
          const inputElement = document.getElementById("fabric-input");
          inputElement.value = fabricTitle;

          document.querySelectorAll(".blind-quote__fabric-dropdown-curtains .js-quote-fabric-blinds").forEach((el) =>
            el.classList.remove("blind-quote__fabric-entry--active")
          );
          this.classList.add("blind-quote__fabric-entry--active");
          dropdownElement.style.display = "none";
          
          populateColorsDropdown(this.dataset.colors);
          
          validateForm();
        });
      });
    };

    const populateColorsDropdown = (colorsData) => {
      const colorsList = document.getElementById("fabric-colors-list");

      if (!colorsList) {
        console.error("Element not found: #fabric-colors-list");
        return;
      }

      let colorsArray;
      try {
        const colorSwatchElement = document.getElementById("color-swatch-images");
        if (!colorSwatchElement) throw new Error('Error parsing JSON data:');

        colorsArray = JSON.parse(colorSwatchElement.textContent);
      } catch (error) {
        console.error(error);
      }

      const colors = colorsData.split(",");
      colorsList.innerHTML = "";
      console.log('colors => ', colors);

      if (colors.length > 0) {
        const firstColor = colorsArray.find(color => color.id == colors[0]);

        const colorInputElement = document.getElementById("blind-fabric-color-input");
        if (colorInputElement) {
          colorInputElement.value = firstColor.title;
          colorInputElement.dispatchEvent(new Event("input"));
          
          validateForm();
        } else {
          console.error("Input element not found: #blind-fabric-color-input");
        }
      }

      colors.forEach((color) => {
        const colorObj = colorsArray.find((col) => col.id === color);
        console.log('colorObj => ', colorObj)
        const li = document.createElement("li");
        li.classList.add("fabric-color-option");
        li.dataset.color = colorObj.title;

        if (colorObj) {
          const img = document.createElement("img");
          img.src = colorObj.image;
          img.alt = colorObj.title;
          img.classList.add("blind-quote__fabric-swatch");

          li.appendChild(img);
        } else {
          console.log("No image found for color:", colorObj.title);
        }

        const span = document.createElement("span");
        span.textContent = colorObj.title;
        li.appendChild(span);

        colorsList.appendChild(li);

        li.addEventListener("click", () => {
          const colorInputElement = document.getElementById("blind-fabric-color-input");
          if (colorInputElement) {
            colorInputElement.value = colorObj.title;
            colorsList.style.display = "none";
            colorInputElement.dispatchEvent(new Event("input"));
            
            validateForm();
          } else {
            console.error("Input element not found: #blind-fabric-color-input");
          }
        });
      });
    };

    const setupColorDropdown = () => {
      const triggerElement = document.querySelector(".js-quote-dropdown-trigger-colors");
      const dropdownElement = document.querySelector(".blind-quote__fabric-colors-list");

      if (!triggerElement || !dropdownElement) {
        console.error("Color dropdown elements not found.");
        return;
      }

      triggerElement.addEventListener("click", function () {
        const span = this.querySelector("span");
        span.classList.toggle("blind-quote__dropdown-trigger--active");
        dropdownElement.style.display = dropdownElement.style.display === "none" ? "block" : "none";
      });

      document.querySelectorAll(".blind-quote__fabric-colors-list .fabric-color-option").forEach((colorOption) => {
        colorOption.addEventListener("click", () => {
          const selectedColor = colorOption.dataset.color;
          const colorInputElement = document.getElementById("blind-fabric-color-input");
          if (colorInputElement) {
            colorInputElement.value = selectedColor;
            dropdownElement.style.display = "none";
            colorInputElement.dispatchEvent(new Event("input"));
            
            validateForm();
          } else {
            console.error("Input element not found: #blind-fabric-color-input");
          }
        });
      });
    };

    setupDropdown(".js-quote-dropdown-trigger-heading", ".heading-quote__fabric-dropdown", "curtain-heading-input");
    setupDropdown(".js-quote-dropdown-trigger-lining", ".lining-quote__fabric-dropdown", "curtain-lining-input");
    setupFabricDropdown();
    setupColorDropdown();

    document.addEventListener("mouseup", (e) => {
      document.querySelectorAll(".js-quote-dropdown").forEach((dropdown) => {
        if (!dropdown.contains(e.target) && !dropdown.previousElementSibling.contains(e.target)) {
          dropdown.style.display = "none";
          const triggerSpan = dropdown.previousElementSibling.querySelector(".blind-quote__dropdown-trigger");
          if (triggerSpan) {
            triggerSpan.classList.remove("blind-quote__dropdown-trigger--active");
          }
        }
      });
    });
  });
